export default "__VITE_ASSET__92aaf558__"